import { React, PropTypes, FelaComponent, childrenPropType } from '../dependencies';

const foodCollectionId = 251966;
const rule = ({ topics, resolution: { width, height }, zIndex }) => ({
    position: 'relative',
    minHeight: '100vh',

    ':after': {
        content: '""',
        /**
         * URL for random images by topic is broken. Until fixing it images from specific food collection are used
         */
        // background: `url(https://source.unsplash.com/${width}x${height}/?${topics.join(',')}) #bf780f`,
        background: `url(https://source.unsplash.com/collection/${foodCollectionId}/${width}x${height}) #bf780f`,
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        opacity: 0.6,
        zIndex,
    },
});

const Background = ({ children, topics, resolution, zIndex }) => {
    return (
        <FelaComponent
            rule={rule}
            topics={topics}
            resolution={resolution}
            zIndex={zIndex}
            render={({ className }) => <div className={className}>{children}</div>}
        />
    );
};

Background.propTypes = {
    topics: PropTypes.arrayOf(PropTypes.string),
    resolution: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
    }),
    zIndex: PropTypes.number,
    children: childrenPropType,
};

Background.defaultProps = {
    topics: [],
    resolution: {
        width: 1600,
        height: 900,
    },
    zIndex: 1,
    children: null,
};

export default Background;
